import {
  Card,
  Label,
  Stack,
  TextField,
} from "@towersystems/roam-common-native";
import {
  Controller,
  useFieldArray,
  useFormContext,
  useWatch,
} from "react-hook-form";
import { toTitleCase } from "@towersystems/roam-common/lib/shared-utils";
import { View } from "react-native-ui-lib";
import { ProductFormValues } from "../../types";
import { useTranslation } from "../../../../../../utilities/i18n";

export const SelectedOptionsFieldArray = () => {
  const { t } = useTranslation("product");
  const { control } = useFormContext<ProductFormValues>();

  const globalDisable = useWatch({ control, name: "globalDisable" });

  const { fields } = useFieldArray({
    control: control,
    name: "selectedOptions",
  });

  if (fields.length === 0) {
    return null;
  }

  return (
    <Stack vertical>
      {fields.map((field, index) => {
        return (
          <View>
            <Label required label={toTitleCase(field.name)}></Label>
            <Controller
              name={`selectedOptions.${index}.value` as const}
              control={control}
              disabled={globalDisable}
              render={({
                field: { onChange, value, onBlur, disabled },
                fieldState: { error },
              }) => (
                <TextField
                  onBlur={onBlur}
                  value={value ?? ""}
                  readonly={disabled}
                  onChangeText={onChange}
                  validationMessage={error ? error.message : undefined}
                  placeholder={t("form.option_value.placeholder")}
                />
              )}
            />
          </View>
        );
      })}
    </Stack>
  );
};
